import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { PeriodProvider } from '@/context/PeriodContext';
import { ThemeProvider } from '@/context/ThemeContext';
import AppLayout from '@/components/AppLayout';
import Login from '@/pages/Login';
import ResetPassword from '@/pages/ResetPassword';
import Dashboard from '@/pages/Dashboard';
import Sales from '@/pages/Sales';
import Expenses from '@/pages/Expenses';
import Deposits from '@/pages/Deposits';
import Conciliation from '@/pages/Conciliation';
import Preform from '@/pages/Preform';
import History from '@/pages/History';
import Settings from '@/pages/Settings';
import Reports from '@/pages/Reports';
import { NipSetupDialog, NipVerifyDialog } from '@/components/NipDialogs';
import '@/index.css';

function Gate() {
  const { user } = useAuth();
  const [nipSetup, setNipSetup] = useState(false);
  const [nipVerify, setNipVerify] = useState(false);

  useEffect(() => {
    const onSetup = () => setNipSetup(true);
    const onNeed = () => setNipVerify(true);
    window.addEventListener('resico:nip-setup-required', onSetup);
    window.addEventListener('resico:nip-required', onNeed);
    return () => {
      window.removeEventListener('resico:nip-setup-required', onSetup);
      window.removeEventListener('resico:nip-required', onNeed);
    };
  }, []);

  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
  if (user === false) return <Login/>;
  return (
    <PeriodProvider>
      <Routes>
        <Route element={<AppLayout/>}>
          <Route path="/" element={<Dashboard/>}/>
          <Route path="/ventas" element={<Sales/>}/>
          <Route path="/gastos" element={<Expenses/>}/>
          <Route path="/depositos" element={<Deposits/>}/>
          <Route path="/conciliacion" element={<Conciliation/>}/>
          <Route path="/preformulario" element={<Preform/>}/>
          <Route path="/historial" element={<History/>}/>
          <Route path="/configuracion" element={<Settings/>}/>
          <Route path="/reportes" element={<Reports/>}/>
        </Route>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
      <NipSetupDialog open={nipSetup} onOpenChange={setNipSetup}/>
      <NipVerifyDialog open={nipVerify} onOpenChange={setNipVerify}/>
    </PeriodProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            {/* Reset password is always accessible without session */}
            <Route path="/reset-password/:token" element={<ResetPassword/>}/>
            <Route path="/*" element={<Gate/>}/>
          </Routes>
          <Toaster richColors position="top-center" theme="system"/>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
